module.exports = __webpack_public_path__ + "static/media/BUSINESSENQUIRY.e1a7e192.jpg";